/**
 * returns viewport dimensions
 * support ssr
 */
export const getViewportDimension = () => {
  if (typeof window !== 'undefined') {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  } else {
    return {
      width: 0,
      height: 0,
    };
  }
};
